// Service status configuration
export const SERVICE_STATUS = {
  octopusSync: true,
  sentinel: true
};

// Helper function to determine overall system status
export const getOverallStatus = () => {
  return SERVICE_STATUS.octopusSync && SERVICE_STATUS.sentinel;
};

// Helper function to get status text
export const getStatusText = () => {
  return getOverallStatus() ? 'All Services Online' : 'System Maintenance';
};
